import BaseUser from "@/project/model/base/BaseUser";

export default class MaterialModel extends BaseUser {

    id = 0;
    code = '';
    name = '';
    type = 0;
    categoryId = '';
    unitId = '';
    safeNum = 0;
    validDay = 0;
    remark = '';

    categoryName = '';
    unitName = '';


}